import { Auth } from "aws-amplify";
import axios from "axios";
import { COGNITO } from "../generated-aws";
const { API_HOST } = COGNITO;

export interface User {
  name: string;
  email: string;
  role: string;
}

export const getUserRoles = async () => {
  const session = await Auth.currentSession();
  const res = await axios.get(`${API_HOST}/user-roles`, {
    headers: {
      Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
    },
  });
  if (res.status === 200) {
    return res.data.users;
  }
  throw new Error(`Unable to fetch the users`);
};

export const addUserRole = async (user: User) => {
  const session = await Auth.currentSession();
  const res = await axios.post(`${API_HOST}/user-roles`, user, {
    headers: {
      Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
    },
  });
  if (res.status === 200) {
    return res.data.user;
  }
  throw new Error("Unable to add the user");
};

export const updateUserRole = async (email: string, role: string) => {
  const session = await Auth.currentSession();
  const res = await axios.put(
    `${API_HOST}/user-roles/${email}`,
    {
      role,
    },
    {
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      },
    },
  );
  if (res.status === 200) {
    return res.data.user;
  }
  throw new Error("Unable to update the user");
};

export const deleteUserRole = async (email: string) => {
  const session = await Auth.currentSession();
  const res = await axios.delete(`${API_HOST}/user-roles/${email}`, {
    headers: {
      Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
    },
  });
  if (res.status === 200) {
    return;
  }
  throw new Error("Unable to delete the user");
};
